import {connect} from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import StepwiseLogs, {DispatchPropsType, MapStateType} from '../organisms/index';

import {InstanceAPIs, Instances, SideBarTypes} from '../../../../constants';
import {IStateType} from '../../../../store/models/root.interface';


import {
	changeOffset,
	makeSelectCount,
	makeSelectFilters,
	makeSelectGlobalCount,
	makeSelectObjectsArray,
	makeSelectOffset,
	makeSelectPaginationInProgress,
	requestObjects,
	makeSelectInProgress, removeObjects, changeSearchStr, updateObjects
} from '../../../../store/Objects';

import {openSideBar} from '../../../../store/sidebar';
import {makeSelectObject, requestObject} from "../../../../store/Object";


const mapStateToProps = () => {
	const selectData = makeSelectObjectsArray(Instances.SipIpAddresses);
	const selectPage = makeSelectOffset(Instances.SipIpAddresses);
	const selectTotal = makeSelectCount(Instances.SipIpAddresses);
	const selectInProgress = makeSelectInProgress(Instances.SipIpAddresses);
	const appliedFilters = makeSelectFilters(Instances.SipIpAddresses);
	const globalTotal = makeSelectGlobalCount(Instances.SipIpAddresses);
	const selectInPaginationProgress = makeSelectPaginationInProgress(Instances.SipIpAddresses);

	return (state: IStateType) => ({
		data: selectData(state),
		page: selectPage(state),
		total: selectTotal(state) || 0,
		inProgress: selectInProgress(state) || false,
		appliedFilters: appliedFilters(state),
		globalTotal: globalTotal(state),
		paginationInProgress: selectInPaginationProgress(state) || false,
	});
};

const mapDispatchToProps = {
	initializeAndLoadData : (
		filters?: Record<string, any>,
		searchTerm?:string,
		dynamicUrlData?:string
	) => requestObjects(
		Instances.SipIpAddresses,
		filters,
		{searchTerm},
		true,
		true,
		dynamicUrlData
		),
	onPaginate: () => changeOffset(Instances.SipIpAddresses),
	removeInstance : () => removeObjects(Instances.SipIpAddresses),
	openAddModal: (params: any) =>
		openSideBar(SideBarTypes.SipAddAclModal, params),
	onDelete: (dynamicUrlData: string, keyForIdentifier:string, cb?: (res: any, success: boolean)=> void) =>  updateObjects(Instances.SipIpAddresses, "DELETE", {}, undefined, undefined, keyForIdentifier, undefined, undefined, cb, dynamicUrlData, InstanceAPIs[Instances.SipIpAddresses].DELETE),
	openRenameModal: (data?: any) => openSideBar(SideBarTypes.RenameSipAclModal, data),
	onSearchTextChange: (searchString: string,dynamicUrlData:string) =>
		changeSearchStr(Instances.SipIpAddresses, searchString,dynamicUrlData),
	removeSipAclInstance : () => removeObjects(Instances.SipACL),
	editSipAcl: (reqData: any,keyForIdentifier:string,dynamicUrl:string, cb?: (res: any, success: boolean)=> void) =>  updateObjects(Instances.SipACL, "PUT", reqData, undefined, undefined, keyForIdentifier, undefined, undefined, cb, dynamicUrl, InstanceAPIs[Instances.SipACL].PUT),
};

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(StepwiseLogs));
